
import {defineComponent, PropType} from 'vue'
import ItemIcons from "@/components/layouts/pim/PimProductsOverviewItemIcons.vue";
import {
  CatalogProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductWithImageOverviewRestDtoModel";

export default defineComponent({
  name: "SelectedProduct",
  emits: ['selectionRemoved'],
  components: {ItemIcons},
  props: {
    product: {
      type: Object as PropType<CatalogProductWithImageOverviewRestDtoModel>,
      required: true,
    },
  },
  methods: {
    deleteSelection() {
      this.$emit('selectionRemoved');
    }
  }
})
